import React, { Component } from "react";
import { Accessor, ColorX, GState, ReqX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XInput, XText } from "IZOX/_X";
import { DOMAIN } from "__SYSDefault/Domain";
import { observer } from "mobx-react";
import {} from "crypto";

/**
 * @augments {Component<Props, State>}
 */
class StartUp extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      username: "",
      password: ""
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(StartUp.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _usernameChange = (text) => {
    this.setState({
      username: text
    });
  }

  _passwordChange = (text) => {
    this.setState({
      password: text
    });
  }

  _login = async () => {
    let {username, password} = this.state;
    let res = await ReqX.SendBE("/CommonAPI/Auth/SignIn", 
      {
        username: username,
        password: password
      });
    let {Success, payload} = res;
    if(Success){
      GState.setUser(payload);
      GState.setLogged(true);
    }
  }

  _test = async () => {
    let res = await ReqX.SendBE("/CommonAPI/Env/Test", 
      {
        test: "testdata"
      });
    let {Success, payload} = res;
    if(Success){
      this.setState({
        testResult: payload
      });
    }
  }

  renderDomain(){
    return (
      <HStack justifyContent="flex-start" spacing={10}>
        <XText style={{fontWeight: "bold"}}>
          {"DOMAIN"}
        </XText>
        <XText>
          {DOMAIN}
        </XText>
      </HStack>
    );
  }

  renderDevName(){
    let {username} = this.state;
    return (
      <HStack justifyContent="flex-start" spacing={10}>
        <XText style={{width: 90, fontWeight: "bold"}}>
          {"Login Name"}
        </XText>
        <XInput onChangeText={this._usernameChange}
          value={username}
          style={{
            borderWidth: 1,
            padding: 5,
            borderRadius: 5
          }}/>
      </HStack>
    );
  }

  renderDevPassword(){
    let {password} = this.state;
    return (
      <HStack justifyContent="flex-start" spacing={10}>
        <XText style={{width: 90, fontWeight: "bold"}}>
          {"Password"}
        </XText>
        <XInput 
          type={"password"}
          onChangeText={this._passwordChange}
          value={password}
          style={{
            borderWidth: 1,
            padding: 5,
            borderRadius: 5
          }}
          />
      </HStack>
    );
  }

  renderLoginBtn(){
    return (
      <XButton onPress={this._login}
        padding={3}
        bgColor={ColorX.BgCSS("blue")}
        color={ColorX.CSS("blue")}
        hoverColor={ColorX.CSS("pureWhite")}
        hoverBgColor={ColorX.CSS("blue")}
        >
        <HStack style={{paddingLeft: 10, paddingRight: 10}}>
          <XText>
            {"Login"}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderTestBtn(){
    return (
      <XButton onPress={this._test}
        padding={3}
        bgColor={ColorX.BgCSS("blue")}
        color={ColorX.CSS("blue")}
        hoverColor={ColorX.CSS("pureWhite")}
        hoverBgColor={ColorX.CSS("blue")}
      >
        <HStack style={{paddingLeft: 10, paddingRight: 10}}>
          <XText>
            {"Test"}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderLoginSection(){
    return (
      <VStack spacing={10}>
        {this.renderDevName()}
        {this.renderDevPassword()}
        {this.renderLoginBtn()}
      </VStack>
    );
  }

  renderJWT(){
    return (
      <HStack justifyContent="flex-start" spacing={10}>
        <XText style={{fontWeight: "bold"}}>
          {"JWT"}
        </XText>
        <XText>
          {GState.user.JWT}
        </XText>
      </HStack>
    );

  }

  renderTestResult(){
    let {testResult} = this.state;
    return (
      <HStack>
        <XText>
          {testResult}
        </XText>
      </HStack>
    );
  }

  renderLogged(){
    return (
      <VStack spacing={10}>
        {this.renderTestResult()}
        {this.renderTestBtn()}
      </VStack>
    );
  }

  render(){
    return (
      <VStack width={"100%"} alignItems="flex-start" style={{padding: 10}} spacing={10}>
        {this.renderDomain()}
        {GState.loggedIn ? 
          this.renderLogged()
          : this.renderLoginSection()}
      </VStack>
    );
  }

}

export default observer(StartUp);
